<template>
  <div
    v-if="attachment"
    class="attachments-show-view"
  >
    <page-header :breadcrumbs="breadcrumbs">
      {{ pageTitle }}
    </page-header>
    <attachment-page
      :show-navigation="showNavigation"
      :attachment="attachment"
      :content-source="contentSource"
      :display-attachment="displayAttachment"
      :next-attachment="nextAttachment"
      :previous-attachment="previousAttachment"
      @goto-attachment="gotoAttachment"
      @done="handleDone"
    />
  </div>
</template>

<script>
import AttachmentPage from '@/components/attachments/page.vue';
import PageHeader from '@/components/singletons/pageHeader.vue';

import AssetPageMixin from '@/mixins/asset-page';
import GlobalMixin from '@/mixins/global';

export default {
  components: {
    AttachmentPage,
    PageHeader,
  },
  mixins: [AssetPageMixin, GlobalMixin],
  computed: {
    attachment() {
      return this.$store.getters['attachments/get'][this.$route.params.attachmentId];
    },
    breadcrumbs() {
      let crumbs = [];
      if (this.$route.query.q) {
        crumbs.push({
          name: 'Search',
          route: {
            name: 'search#index',
            query: {
              q: this.$route.query.q,
            },
          },
        });
      }
      crumbs.push({ name: this.attachment.assetTitle });
      return crumbs;
    },
    contentSource() {
      if (this.attachment?.contentSourceId) {
        return this.$store.getters['contentSources/get'][this.attachment.contentSourceId];
      }
    },
    nextAttachment() {
      if (this.positionInSearch === -1 || this.positionInSearch >= this.searchRecords.length - 1) {
        return null;
      }
      const nextAttachmentId = this.searchRecords[this.positionInSearch + 1];
      return this.$store.getters['attachments/get'][nextAttachmentId];;
    },
    pageTitle() {
      return `Search '${this.$route.query.q}'`;
    },
    previousAttachment() {
      if (this.positionInSearch < 1) {
        return null;
      }
      const previousAttachmentId = this.searchRecords[this.positionInSearch - 1];
      return this.$store.getters['attachments/get'][previousAttachmentId];
    },
    positionInSearch() {
      return this.searchRecords.indexOf(this.attachment.id);
    },
    searchRecords() {
      return this.$store.getters['attachments/searchData'].records;
    },
    showNavigation() {
      return this.positionInSearch !== -1;
    },
  },
  mounted() {
    let ids = [this.$route.params.attachmentId];
    if (this.contentSource?.previewAttachmentId) {
      ids.push(this.contentSource.previewAttachmentId);
    }
    this.$store.dispatch('attachments/fetch', { ids });
  },
  methods: {
    gotoAttachment(attachment) {
      return this.$router.push({
        name: 'search#attachment',
        params: {
          attachmentId: attachment.id,
        },
        query: this.$route.query,
      });
    },
    handleDone() {
      return this.$router.push({
        name: 'search#index',
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments-show-view {
  .bookmark-button {
    height: 100%;
    margin-left: rem-calc(48);

    @include breakpoint(small) {
      margin-left: rem-calc(24);
    }
  }
}
</style>
